module.exports = __webpack_public_path__ + "static/media/settingsLogo.fbb62595.svg";